<template>
  <VpListLayout add-route="cards-create" feature="CARDS">
    <VpList
      :per-page="10"
      :columns="columns"
      endpoint="cards"
      cache="cards"
      :request-payload="{ query: $options.cards }"
      class="vp-h-full"
      ref="list"
      title="Cards"
      @rowClick="
        $router.push({
          name: 'card',
          params: {
            cardId: $event.id,
          },
        })
      "
      feature="CARDS"
    >
      <template #empty>
        <VpFeature the-key="CARDS" #default="{ feature }">
          <VpListEmpty :feature="feature" route="card" />
        </VpFeature>
      </template>

      <template #subdomainUrl="{ item }">
        <VyButton
          :href="item.subdomainUrl"
          target="_blank"
          :label="item.subdomainUrl"
          class="button--primary"
        />
      </template>

      <template #view="{ item }">
        <VyButton
          :href="item.subdomainUrl"
          target="_blank"
          :icon="$options.icons.OpenInNew"
          label="View"
          class="button--muted button--rounded button--gray button--md"
        />
      </template>
    </VpList>
  </VpListLayout>
</template>

<script>
import { OpenInNew } from "icons/icons.js";
import cards from "./collection.gql";

export default {
  cards,
  icons: {
    OpenInNew,
  },

  computed: {
    columns() {
      return [
        { name: "_index", label: "#", type: "string" },
        { name: "name", type: "string" },
        {
          name: "subdomainUrl",
          type: "string",
          label: "Link",
          rowClick: false,
          fix: true,
        },
        { name: "view", label: "", fix: true, rowClick: false },
      ];
    },
  },
};
</script>
